/* NZS collection filters — client-side, category-aware faceted filtering + grid density.
   Reads config from #nzs-filter-config and per-card data-* (incl. data-ing = custom.filter_facets.ing).
   Registers Alpine.data('nzsFilters'). No dependency on the native facets.js engine. */
(function () {
  function readConfig() {
    try { return JSON.parse(document.getElementById('nzs-filter-config').textContent); }
    catch (e) { console.warn('[nzs-filters] config parse failed', e); return null; }
  }
  function niceCeil(v, step) { step = step || 1; return Math.ceil(v / step) * step; }
  function num(v) { v = parseFloat(v); return isFinite(v) ? v : null; }
  function validManifest(m) {
    var nums = ['n','price_max','pps_max','srv_max','grams_max'], objs = ['ing_max','toggles','tags','flavour','avail','cat'];
    return !!(m && m.v === 1 && nums.every(function (k) { return typeof m[k] === 'number' && isFinite(m[k]); }) &&
      objs.every(function (k) { return m[k] && typeof m[k] === 'object' && !Array.isArray(m[k]); }));
  }
  var _nzsFullP = null;   // render-window: ONE ?view=nzs-full fetch per page, shared across nzsFilters instances (non-reactive on purpose)

  function nzsFilters() {
    return {
      cfg: null,
      manifest: null,
      shopAll: false,
      cat: '',
      catList: [],
      subcats: [],          // [{handle,label,count}] — sub-categories present in THIS collection (filter chips)
      subcatMeta: [],       // raw {handle,label} list from #nzs-subcats (counts derived per-page)
      subcatSel: [],        // selected sub-category handles (OR within, AND with the rest)
      catGroup: [],         // NZS-BRANDCAT: top-level categories present (brand/benefit/misc pages) -> "Category" selector
      catSel: [],           // selected top-level category keys (OR within, AND with the rest)
      cards: [],            // [{el, cat, price, onsale, srv, pps, grams, instock, tags:[], ing:{}, fams:[], title}]
      order: [],            // original DOM order (card els) for 'featured'
      sliders: [],          // active slider objects (price, pps, srv, grams, ...ingredients)
      groups: [],           // [{ns,label,options:[{slug,label,count}], sel:[], open}]
      flavour: null,        // {label, options:[{key,label,count}], sel:[], open}
      toggles: [],          // [{key,label,on}]
      availabilityOn: false, // dedicated "In stock only" control, rendered after Price
      availabilityCounts: { in: 0, out: 0 },
      testedOn: false,       // NZS-TFS: "Tested for Sport" toggle (any cert:* tag); hidden on the tested-for-sport collection
      testedCount: 0,
      _isTfs: false,
      sorts: [],
      sort: 'featured',
      density: 'small',
      count: 0,
      total: 0,
      ready: false,
      baseParams: null,
      isSearch: false,
      drawerOpen: false,
      _filterOverlay: null,
      _filterFallbackClose: null,
      _filterEnhance: null,
      listLayout: false,   // mirrors density==='list' so card-product's :class="listLayout?..." resolves
      _t: null,
      // --- infinite-scroll render window (Blake 2026-06-28) ---
      shown: 0,
      _winBusy: false,
      _cols: 0,
      _matchingCount: 0,
      _io: null,
      sentinel: null,
      loaderEl: null,
      _rt: null,
      // --- render-window card stub upgrade (Blake 2026-07-10): stub cards beyond
      // section.settings.render_window ship without the heavy inner card HTML; _fullPromise/_fullMap
      // cache a single background fetch of the "?view=nzs-full" (render_window:0) alt-view so stub
      // cards can be swapped for the real card the first time they enter the reveal window. ---
      _fullPromise: null,
      _fullMap: null,
      _loadingMore: false,
      _allPagesLoaded: false,
      _collectionPage: 0,
      _collectionPages: 0,
      _collectionLoaded: null,
      _loadAllRequested: false,
      _pageAbort: null,
      _pageSeq: 0,
      _searchWasUntyped: false,
      _loadError: false,
      _loadErrorTimer: null,
      // --- NZS-PGN (Blake 2026-07-20): Products/page selector + client pager. perPage 0 = server
      // default (paginate 36, real ?page=N links). 20/30/40/50/60 = client mode: fetch all server
      // pages, then window the matching set at perPage via the bottom pager. URL never touched. ---
      perPage: 0,
      cpPage: 1,
      cpPages: 1,
      _pagerUi: false,
      _srvPpg: 36,

      get gridClass() { return 'nzs-density-' + this.density + (this.density === 'list' ? ' list-layout' : ''); },
      get brandCat() { return !this.shopAll && !this.cat; },  // brand/benefit/misc page -> two-level Category selector
      get clientPaging() { return this.perPage > 0 && this._pagerUi; },  // NZS-PGN: only where the pager UI exists (not /search)
      get showTested() { return !this._isTfs && this.testedCount > 0; }, // NZS-TFS
      get cpPageList() {  // NZS-PGN: numbered pager model (0 = ellipsis)
        var t = this.cpPages, c = this.cpPage, out = [], i;
        if (t <= 7) { for (i = 1; i <= t; i++) out.push({ k: 'p' + i, n: i }); return out; }
        out.push({ k: 'p1', n: 1 });
        if (c > 3) out.push({ k: 'e1', n: 0 });
        for (i = Math.max(2, c - 1); i <= Math.min(t - 1, c + 1); i++) out.push({ k: 'p' + i, n: i });
        if (c < t - 2) out.push({ k: 'e2', n: 0 });
        out.push({ k: 'p' + t, n: t });
        return out;
      },

      init() {
        this.cfg = readConfig();
        if (!this.cfg) return;
        var root = this.$root, currentUrl = new URL(location.href);
        var facetIndex = root.querySelector('#nzs-facet-index');
        if (facetIndex) {
          try { var manifest = JSON.parse(facetIndex.textContent); this.manifest = validManifest(manifest) ? manifest : null; }
          catch (e) { console.warn('[nzs-filters] facet manifest parse failed', e); }
        }
        this.baseParams = new URLSearchParams(currentUrl.search);
        this.isSearch = root.dataset.nzsSearch === 'true';
        this._searchWasUntyped = this.isSearch && this.baseParams.get('type') !== 'product';
        if (this.isSearch) this.baseParams.set('type', 'product');
        this.cat = (root.dataset.activeCat || '').trim();
        // shopAll = the true all-products / cross-category pages only (shop-all, tested-for-sport).
        // Brand / benefit / misc pages have an empty cat but are NOT shopAll -> "plain mode"
        // (price/tags/flavour/availability/sort; no ingredient sliders, no category-picker, no Goal).
        this.shopAll = root.dataset.shopAll === 'true';
        this._isTfs = root.dataset.nzsTfs === 'true';   // NZS-TFS: hide the toggle where it is redundant
        var catHandle = { preworkout: 'pre-workout', protein: 'protein', creatine: 'creatine', amino: 'amino-bcaa', massgainer: 'mass-gainers', electrolyte: 'electrolytes', fatburner: 'weight-management', health: 'health-wellness' };
        this.catList = Object.keys(this.cfg.categories).filter(function (k) { return k !== 'other'; })
          .map(function (k) { return { key: k, label: this.cfg.categories[k].label, handle: catHandle[k] || k }; }.bind(this));
        try { this.subcatMeta = JSON.parse(document.getElementById('nzs-subcats').textContent) || []; } catch (e) { this.subcatMeta = []; }
        this.grid = root.querySelector('[data-nzs-grid]');
        if (!this.isSearch && this.grid) {
          this._collectionPage = parseInt(this.grid.dataset.nzsCurrentPage || '1', 10);
          this._collectionPages = parseInt(this.grid.dataset.nzsPages || '0', 10);
          this._collectionLoaded = {};
          this._collectionLoaded[this._collectionPage] = true;
          this._allPagesLoaded = this._collectionPages === 1;
        }
        this.collectCards();
        this.density = localStorage.getItem('nzs-density3') || 'small'; if (this.density === 'list') this.density = 'small';
        // NZS-PGN: restore the Products/page choice; only honoured where the pager UI exists
        // (the collection section). /search shares this engine but has no pager markup -> untouched.
        this._pagerUi = !!root.querySelector('[data-nzs-ppp]');
        this._srvPpg = parseInt((this.grid && this.grid.dataset.nzsPpg) || '36', 10) || 36;
        try { var _pp = parseInt(localStorage.getItem('nzsPerPage') || '0', 10); if ([20, 30, 40, 50, 60].indexOf(_pp) >= 0) this.perPage = _pp; } catch (e) { }
        this.buildControls();
        this.hydrateFromUrl();
        this.listLayout = this.density === 'list';
        this.ready = true;
        this.$nextTick(function () { this.apply(false); }.bind(this));
        this.setupScroll();
        this.initFilterDrawer();
        // NZS-PGN: a restored per-page choice needs the full set before it can window past the loaded page(s)
        if (this.clientPaging && !this._allPagesLoaded) { var s2 = this; this.$nextTick(function () { s2.filterIntent(); }); }
        if (this.isSearch || this._collectionPages) {
          var self = this;
          window.addEventListener('popstate', function () { self.abortLoad(); location.reload(); });
          window.addEventListener('pagehide', function () { self.abortLoad(); }, { once: true });
        }
      },

      /* ---------- collection page loading: one page for scroll, every missing page for filter/sort ---------- */
      collectionHasNextPage() {
        return this._collectionPage < this._collectionPages;
      },
      initFilterDrawer() {
        var self = this;
        this._filterFallbackClose = function () { self.drawerOpen = false; };
        window.__nzsSurfaces = window.__nzsSurfaces || {};
        window.__nzsSurfaces.filter = this._filterFallbackClose;
        this.enhanceFilterDrawer();
        if (!this._filterOverlay) {
          this._filterEnhance = function () { self.enhanceFilterDrawer(); };
          if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this._filterEnhance, { once: true });
          window.addEventListener('load', this._filterEnhance, { once: true });
        }
      },
      enhanceFilterDrawer() {
        if (this._filterOverlay || !window.nzsOverlay || typeof window.nzsOverlay.enhance !== 'function') return;
        var root = this.$root.querySelector('[data-nzs-filter-dialog]');
        var trigger = this.$root.querySelector('[data-nzs-filter-trigger]');
        if (!root || !trigger) return;
        var self = this, wasOpen = this.drawerOpen;
        this._filterOverlay = window.nzsOverlay.enhance({
          root: root,
          trigger: trigger,
          key: 'filter',
          label: 'Filters',
          onOpen: function () { self.drawerOpen = true; },
          onClose: function () { self.drawerOpen = false; }
        });
        if (wasOpen) {
          this.drawerOpen = false;
          this._filterOverlay.open();
        }
      },
      openFilterDrawer() {
        this.enhanceFilterDrawer();
        if (this._filterOverlay) { this._filterOverlay.open(); return; }
        if (window.__nzsCloseAllExcept) window.__nzsCloseAllExcept('filter');
        this.drawerOpen = true;
      },
      closeFilterDrawer() {
        this.enhanceFilterDrawer();
        if (this._filterOverlay) { this._filterOverlay.close(); return; }
        this.drawerOpen = false;
      },
      openFilters() { this.openFilterDrawer(); this.filterIntent(); },
      filterIntent() {
        if (this.isSearch) { if (!this._allPagesLoaded && !this._loadingMore) this.loadSearchPages(); return; }
        if (this._allPagesLoaded) return;
        this._loadAllRequested = true;
        if (!this._loadingMore) this.loadCollectionPages(true);
      },
      abortLoad() {
        if (this._pageAbort) this._pageAbort.abort();
        this._pageAbort = null;
        this._pageSeq++;
        this._loadingMore = false;
      },
      loadCollectionPages(loadAll) {
        if (this.isSearch || !this.grid || this._allPagesLoaded || this._loadingMore) return;
        var self = this, pages = parseInt(this.grid.dataset.nzsPages || '0', 10);
        if (!pages) { this._allPagesLoaded = true; return; }
        this._collectionPages = pages;
        if (!this._collectionLoaded) {
          this._collectionPage = parseInt(this.grid.dataset.nzsCurrentPage || '1', 10);
          this._collectionLoaded = {};
          this._collectionLoaded[this._collectionPage] = true;
        }
        var page = loadAll ? 1 : this._collectionPage + 1;
        while (page <= pages && this._collectionLoaded[page]) page++;
        if (page > pages) { if (loadAll) this._allPagesLoaded = true; this.updateSentinel(this._matchingCount); return; }
        var controller = new AbortController(), seq = ++this._pageSeq, seen = {};
        Array.prototype.forEach.call(this.grid.querySelectorAll('[data-nzs-card][data-pid]'), function (n) { seen[n.getAttribute('data-pid')] = true; });
        this._pageAbort = controller;
        this._loadingMore = true;
        clearTimeout(this._loadErrorTimer);
        this._loadErrorTimer = null;
        this._loadError = false;
        this.showLoader(true);
        function allLoaded() {
          for (var i = 1; i <= pages; i++) { if (!self._collectionLoaded[i]) return false; }
          return true;
        }
        function finish(complete) {
          if (seq !== self._pageSeq) return;
          self._pageAbort = null;
          self._loadingMore = false;
          if (complete) self._allPagesLoaded = allLoaded();
          else {
            self._loadError = true;
            clearTimeout(self._loadErrorTimer);
            self._loadErrorTimer = setTimeout(function () { self._loadError = false; self._loadErrorTimer = null; }, 3000);
          }
          self.showLoader(false);
          self.updateSentinel(self._matchingCount);
          if (complete && loadAll) self.writeUrl(true);
          if (complete && !loadAll && self._loadAllRequested && !self._allPagesLoaded) self.loadCollectionPages(true);
        }
        (function fetchPage() {
          if (seq !== self._pageSeq || controller.signal.aborted) return;
          while (page <= pages && self._collectionLoaded[page]) page++;
          if (page > pages) { finish(true); return; }
          var requestedPage = page, url = new URL(location.href);
          url.searchParams.set('page', requestedPage);
          fetch(url.href, { headers: { 'X-Requested-With': 'fetch' }, signal: controller.signal })
            .then(function (r) { if (!r.ok) throw new Error('Collection page fetch failed: ' + r.status); return r.text(); })
            .then(function (html) {
              if (seq !== self._pageSeq) return;
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var add = doc.querySelectorAll('[data-nzs-grid] [data-nzs-card]');
              var frag = document.createDocumentFragment();
              Array.prototype.forEach.call(add, function (n) {
                var pid = n.getAttribute('data-pid');
                if (!pid || seen[pid]) return;
                seen[pid] = true;
                frag.appendChild(document.importNode(n, true));
              });
              var fresh = Array.prototype.slice.call(frag.childNodes);
              self.grid.appendChild(frag);
              if (window.Alpine && window.Alpine.initTree) {
                fresh.forEach(function (n) { if (n.nodeType === 1) window.Alpine.initTree(n); });
              }
              self._collectionLoaded[requestedPage] = true;
              self._collectionPage = Math.max(self._collectionPage, requestedPage);
              var shown = self.shown;
              self.collectCards();
              self.buildControls();
              self.hydrateFromUrl();
              self.apply(false);
              if (!loadAll) shown += self.windowConsts().STEP;
              if (shown > self.shown) { self.shown = shown; self.applyWindow(); }
              page = requestedPage + 1;
              if (loadAll) fetchPage(); else finish(true);
            })
            .catch(function (e) { if (e.name !== 'AbortError') finish(false); });
        })();
      },
      loadSearchPages() {
        if (!this.grid || this._allPagesLoaded || this._loadingMore) return;
        if (this._pageAbort) this._pageAbort.abort();
        var self = this, controller = new AbortController(), seq = ++this._pageSeq;
        var currentPage = parseInt(this.grid.dataset.nzsCurrentPage || '1', 10);
        var pages = parseInt(this.grid.dataset.nzsPages || '0', 10), seen = {}, pageList = [], buffered = {}, next = 0, failed = false;
        if (!pages) { this._allPagesLoaded = true; return; }
        for (var page = 1; page <= pages; page++) {
          if (page !== currentPage || this._searchWasUntyped) pageList.push(page);
        }
        Array.prototype.forEach.call(this.grid.querySelectorAll('[data-nzs-card][data-pid]'), function (n) { seen[n.getAttribute('data-pid')] = true; });
        this._pageAbort = controller;
        this._loadingMore = true;
        clearTimeout(this._loadErrorTimer);
        this._loadErrorTimer = null;
        this._loadError = false;
        function finish(complete) {
          if (seq !== self._pageSeq) return;
          self._pageAbort = null;
          self._loadingMore = false;
          if (complete) self._allPagesLoaded = true;
          else {
            self._allPagesLoaded = false;
            self._loadError = true;
            clearTimeout(self._loadErrorTimer);
            self._loadErrorTimer = setTimeout(function () { self._loadError = false; self._loadErrorTimer = null; }, 3000);
          }
          self.afterLoadMore(true);
        }
        function wait(ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); }
        function requestPage(requestedPage, attempt) {
          var params = new URLSearchParams(self.baseParams);
          params.set('page', requestedPage);
          params.set('section_id', 'nzs-search-data');
          var url = location.pathname + '?' + params.toString();
          return fetch(url, { headers: { 'X-Requested-With': 'fetch' }, signal: controller.signal })
            .then(function (r) {
              if (!r.ok) {
                var statusError = new Error('Search section fetch failed: ' + r.status);
                statusError.retryable = r.status === 429 || r.status >= 500;
                throw statusError;
              }
              return r.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var add = Array.prototype.slice.call(doc.querySelectorAll('[data-nzs-grid] [data-nzs-card]'));
              if (!add.length) {
                var emptyError = new Error('Search section returned no cards for page ' + requestedPage);
                emptyError.retryable = true;
                throw emptyError;
              }
              return add;
            })
            .catch(function (e) {
              if (e.name === 'AbortError' || attempt || !e.retryable) throw e;
              return wait(400 + Math.floor(Math.random() * 401)).then(function () {
                if (seq !== self._pageSeq || controller.signal.aborted) return [];
                return requestPage(requestedPage, 1);
              });
            });
        }
        function worker() {
          if (seq !== self._pageSeq || controller.signal.aborted || next >= pageList.length) return Promise.resolve();
          var requestedPage = pageList[next++];
          return requestPage(requestedPage, 0)
            .then(function (add) { if (add.length) buffered[requestedPage] = add; })
            .catch(function (e) { if (e.name !== 'AbortError') failed = true; })
            .then(worker);
        }
        var workers = [];
        for (var i = 0; i < Math.min(4, pageList.length); i++) workers.push(worker());
        Promise.all(workers).then(function () {
          if (seq !== self._pageSeq || controller.signal.aborted) return;
          pageList.forEach(function (requestedPage) {
            var add = buffered[requestedPage];
            if (!add) return;
            var frag = document.createDocumentFragment();
            add.forEach(function (n) {
              var pid = n.getAttribute('data-pid');
              if (!pid || seen[pid]) return;
              seen[pid] = true;
              frag.appendChild(document.importNode(n, true));
            });
            var fresh = Array.prototype.slice.call(frag.childNodes);
            self.grid.appendChild(frag);
            if (window.Alpine && window.Alpine.initTree) {
              fresh.forEach(function (n) { if (n.nodeType === 1) window.Alpine.initTree(n); });
            }
          });
          finish(!failed);
        });
      },
      afterLoadMore(programmatic) {
        this._loadingMore = false;
        // Rebuild the rail over the full card set, then restore the user's active filters from the URL.
        this.collectCards();
        this.buildControls();
        this.hydrateFromUrl();
        this.apply(false);
        if (programmatic) this.writeUrl(true);
      },

      /* ---------- card ingestion ---------- */
      collectCards() {
        var els = Array.prototype.slice.call(this.$root.querySelectorAll('[data-nzs-card]'));
        if (this.isSearch) els.sort(function (a, b) {
          return (parseInt(a.dataset.nzsPage || '1', 10) - parseInt(b.dataset.nzsPage || '1', 10)) ||
            (parseInt(a.dataset.nzsIndex || '0', 10) - parseInt(b.dataset.nzsIndex || '0', 10));
        });
        this.order = els.slice();
        this.cards = els.map(function (el) {
          var ing = {};
          try { ing = JSON.parse(el.dataset.ing || '{}') || {}; } catch (e) { ing = {}; }
          var tags = (el.dataset.tags || '').split('|').filter(Boolean);
          var subcats = (el.dataset.subcats || '').split('|').filter(Boolean);
          var c = {
            el: el,
            cat: el.dataset.cat || 'other',
            price: num(el.dataset.price),
            onsale: el.dataset.onsale === 'true',
            srv: num(el.dataset.srv),
            pps: num(el.dataset.pps),
            grams: num(el.dataset.grams),
            instock: el.dataset.instock !== 'false',
            title: (el.dataset.title || '').toLowerCase(),
            tags: tags,
            subcats: subcats,
            ing: ing,
            fams: []
          };
          c.fams = this.familiesOf(tags);
          el._nzs = c;
          return c;
        }.bind(this));
        /* NZS-TRUECOUNT: collections paginate by 36, so cards.length is only the loaded page(s).
           The grid carries the server-side count (data-nzs-total, gift-placeholder already
           excluded); prefer it so the toolbar reads the collection, not the DOM. */
        var _srv = parseInt((this.grid && this.grid.dataset.nzsTotal) || '', 10);
        this.total = (_srv > 0 ? Math.max(_srv, this.cards.length) : this.cards.length);
      },
      flavourSlugs(tags) {
        var out = [];
        tags.forEach(function (t) { if (t.indexOf('flavour:') === 0) out.push(t.slice(8)); });
        return out;
      },
      familiesOf(tags) {
        if (!this.cfg.flavour) return [];
        var slugs = this.flavourSlugs(tags), fams = this.cfg.flavour.families, out = [];
        Object.keys(fams).forEach(function (fam) {
          var kws = fams[fam];
          for (var i = 0; i < slugs.length; i++) {
            for (var j = 0; j < kws.length; j++) { if ((function (sl, kw) { if (kw.indexOf('-') >= 0) return ('-' + sl + '-').indexOf('-' + kw + '-') >= 0; var sg = sl.split('-'); for (var x = 0; x < sg.length; x++) { var g = sg[x]; if (g === kw || g.slice(0, kw.length) === kw || g.slice(g.length - kw.length) === kw) return true; } return false; })(slugs[i], kws[j])) { out.push(fam); return; } }
          }
        });
        return out;
      },

      /* ---------- build the filter rail from present data ---------- */
      buildControls() {
        var cards = this.cards, manifest = this.manifest, disclosureState = {};
        if (this.ready) {
          (this.groups || []).forEach(function (g) { disclosureState['group:' + g.ns] = { open: g.open, showAll: g.showAll }; });
          if (this.flavour) disclosureState['flavour:' + this.flavour.label] = { open: this.flavour.open };
          (this.sliders || []).forEach(function (s) { if (s.kind === 'ing') disclosureState['slider:' + s.label] = { open: s.open }; });
        }
        if (manifest && num(manifest.n) != null) this.total = num(manifest.n);
        // Ingredient sliders + category toggles only exist on a single resolved category page.
        // All-products (shop-all) and brand/benefit/misc pages have no single category -> catCfg null
        // -> no ingredient sliders (per Blake: too many ingredients span the whole catalogue).
        var catCfg = this.cat ? (this.cfg.categories[this.cat] || null) : null;

        // numeric range sliders: price, pps, servings, grams
        var maxPrice = 0, maxPps = 0, maxSrv = 0, maxGrams = 0, hasPps = false, hasSrv = false, hasGrams = false;
        if (manifest) {
          maxPrice = num(manifest.price_max) || 0; maxPps = num(manifest.pps_max) || 0;
          maxSrv = num(manifest.srv_max) || 0; maxGrams = num(manifest.grams_max) || 0;
          hasPps = hasSrv = (num(manifest.n) || 0) > 0; hasGrams = maxGrams > 0;
        } else {
          cards.forEach(function (c) {
            if (c.price != null) maxPrice = Math.max(maxPrice, c.price);
            if (c.pps != null) { maxPps = Math.max(maxPps, c.pps); hasPps = true; }
            if (c.srv != null) { maxSrv = Math.max(maxSrv, c.srv); hasSrv = true; }
            if (c.grams != null) { maxGrams = Math.max(maxGrams, c.grams); hasGrams = true; }
          });
        }
        var sliders = [];
        sliders.push(this.mkSlider('price', 'price', 'Price', '$', 100, 0, niceCeil(maxPrice, 500) || 100, 100));
        if (hasPps && maxPps > 0) sliders.push(this.mkSlider('pps', 'pps', 'Price / serve', '$', 100, 0, niceCeil(maxPps, 25) || 50, 5));
        if (hasSrv && maxSrv > 0) sliders.push(this.mkSlider('srv', 'srv', 'Servings', '', 1, 0, niceCeil(maxSrv, 5) || 30, 1));
        if (hasGrams && maxGrams > 0) sliders.push(this.mkSlider('grams', 'grams', 'Size', 'g', 1, 0, niceCeil(maxGrams, 100) || 500, 50));

        // category ingredient sliders (only those present on >=1 card; single-category pages only)
        ((catCfg && catCfg.ingredients) || []).forEach(function (ing) {
          var present = manifest ? Object.prototype.hasOwnProperty.call(manifest.ing_max || {}, ing.key) :
            cards.some(function (c) { return c.ing && c.ing[ing.key] != null; });
          if (!present) return;
          sliders.push(this.mkSlider('ing', ing.key, ing.label, ing.unit, ing.div, 0, ing.max, ing.step));
        }.bind(this));
        sliders.forEach(function (s) {
          if (s.kind !== 'ing') return;
          var saved = disclosureState['slider:' + s.label];
          if (saved) { s.open = saved.open; s._openRestored = true; }
        });
        this.sliders = sliders;

        // tag checkbox groups (present namespaces only)
        var groups = [];
        (this.cfg.tagGroups || []).forEach(function (g) {
          if (g.shopAllOnly && !this.shopAll) return;  // e.g. Goal: only on the all-products page
          var counts = manifest ? ((manifest.tags && manifest.tags[g.ns]) || {}) : {};
          if (!manifest) {
            cards.forEach(function (c) {
              c.tags.forEach(function (t) {
                if (t.indexOf(g.ns + ':') === 0) { var v = t.slice(g.ns.length + 1); counts[v] = (counts[v] || 0) + 1; }
              });
            });
          }
          var opts = Object.keys(counts).sort().map(function (slug) { return { slug: slug, label: this.titleize(slug), count: counts[slug] }; }.bind(this));
          if (opts.length) {
            var saved = disclosureState['group:' + g.ns];
            groups.push({ ns: g.ns, label: g.label, options: opts, sel: [], open: saved ? saved.open : false, showAll: saved ? saved.showAll : false, _openRestored: !!saved });
          }
        }.bind(this));
        this.groups = groups;

        // sub-category chips: count present members in THIS collection, drop zero, keep #nzs-subcats order
        var subCounts = {};
        cards.forEach(function (c) { c.subcats.forEach(function (h) { subCounts[h] = (subCounts[h] || 0) + 1; }); });
        this.subcats = (this.subcatMeta || []).filter(function (m) { return subCounts[m.handle]; })
          .map(function (m) { return { handle: m.handle, label: m.label, count: subCounts[m.handle] }; });

        // NZS-BRANDCAT: top-level Category selector (brand/benefit/misc pages only — no single resolved cat).
        // Built from each card's data-cat, in config category order, labelled from the config ('other' -> 'Other').
        if (this.brandCat) {
          var catCounts = manifest ? (manifest.cat || {}) : {};
          if (!manifest) cards.forEach(function (c) { catCounts[c.cat] = (catCounts[c.cat] || 0) + 1; });
          var catOrder = Object.keys(this.cfg.categories);
          Object.keys(catCounts).forEach(function (k) { if (catOrder.indexOf(k) < 0) catOrder.push(k); });
          this.catGroup = catOrder.filter(function (k) { return catCounts[k]; }).map(function (k) {
            var label = (k === 'other') ? 'Other' : ((this.cfg.categories[k] && this.cfg.categories[k].label) || this.titleize(k));
            return { key: k, label: label, count: catCounts[k] };
          }.bind(this));
        } else {
          this.catGroup = [];
        }

        // flavour families present
        var famCount = manifest ? (manifest.flavour || {}) : {};
        if (!manifest) cards.forEach(function (c) { c.fams.forEach(function (f) { famCount[f] = (famCount[f] || 0) + 1; }); });
        var famOrder = Object.keys(this.cfg.flavour ? this.cfg.flavour.families : {});
        var famOpts = famOrder.filter(function (f) { return famCount[f]; }).map(function (f) { return { key: f, label: this.titleize(f), count: famCount[f] }; }.bind(this));
        var flavourLabel = this.cfg.flavour ? (this.cfg.flavour.label || 'Flavour') : 'Flavour';
        var flavourSaved = disclosureState['flavour:' + flavourLabel];
        this.flavour = famOpts.length ? { label: flavourLabel, options: famOpts, sel: [], open: flavourSaved ? flavourSaved.open : false, _openRestored: !!flavourSaved } : null;

        // toggles: category toggles (present, single-category pages only) + on_sale (if any) + in_stock
        var toggles = [];
        ((catCfg && catCfg.toggles) || []).forEach(function (k) {
          var def = this.cfg.toggleDefs[k]; if (!def) return;
          var n = manifest ? ((manifest.toggles && manifest.toggles[k]) || 0) :
            this.cards.filter(function (c) { return this.togglePass(c, def); }.bind(this)).length;
          if (n) toggles.push({ key: k, label: def.label, on: false, count: n });
        }.bind(this));
        var onsaleN = cards.filter(function (c) { return c.onsale; }).length;
        if (onsaleN) toggles.push({ key: 'on_sale', label: 'On sale', on: false, count: onsaleN });
        this.toggles = toggles;  // in-stock is its own dedicated control (rendered after Price)

        var availCounts = { in: 0, out: 0 };
        if (manifest) {
          availCounts.in = num(manifest.avail && manifest.avail.in) || 0;
          availCounts.out = num(manifest.avail && manifest.avail.out) || 0;
        } else {
          cards.forEach(function (c) { availCounts[c.instock ? 'in' : 'out']++; });
        }
        this.availabilityCounts = availCounts;

        // NZS-TFS: count = cards carrying any cert:* tag (drug-tested certification namespace)
        this.testedCount = cards.filter(function (c) { return c.tags.some(function (t) { return t.indexOf('cert:') === 0; }); }).length;

        // sorts (drop pps/srv sorts if data absent)
        this.sorts = (this.cfg.sorts || []).filter(function (s) {
          if (s.key === 'pps-asc' && !hasPps) return false;
          if (s.key === 'srv-desc' && !hasSrv) return false;
          return true;
        });
      },
      mkSlider(kind, key, label, unit, div, min, max, step) {
        return { id: kind + '-' + key, kind: kind, key: key, label: label, unit: unit, div: div, min: min, max: max, step: step, lo: min, hi: max, open: kind !== 'ing', _openRestored: false };
      },
      toggleHasMatches(def) {
        return this.cards.some(function (c) { return this.togglePass(c, def); }.bind(this));
      },
      titleize(s) {
        return (s || '').replace(/[-_]+/g, ' ').replace(/\b\w/g, function (m) { return m.toUpperCase(); }).replace(/\bBcaa\b/, 'BCAA').replace(/\bEaa\b/, 'EAA').replace(/\bRtd\b/, 'RTD').replace(/\bNsf\b/, 'NSF');
      },

      /* ---------- matching ---------- */
      sliderActive(s) { return s.lo > s.min || s.hi < s.max; },
      cardValue(c, s) {
        if (s.kind === 'price') return c.price;
        if (s.kind === 'pps') return c.pps;
        if (s.kind === 'srv') return c.srv;
        if (s.kind === 'grams') return c.grams;
        if (s.kind === 'ing') return (c.ing && c.ing[s.key] != null) ? c.ing[s.key] : null;
        return null;
      },
      togglePass(c, def) {
        if (def.type === 'tag') return c.tags.indexOf(def.tag) >= 0;
        var v = (c.ing && c.ing[def.key] != null) ? c.ing[def.key] : null;
        if (def.type === 'ing_absent0') return v == null || v === 0;   // e.g. caffeine-free: no caffeine listed, or 0
        if (def.type === 'ing_zero') return v === 0;                   // e.g. sugar-free: an explicit 0 on the panel
        if (def.type === 'ingmax') return v != null && v <= def.max;
        if (def.type === 'ingmin') return v != null && v >= def.min;
        return false;
      },
      matches(c) {
        // category (shop-all with a picked category)
        if (this.shopAll && this.cat && c.cat !== this.cat) return false;
        // top-level Category selector (brand/misc pages; OR within, AND with the rest)
        if (this.catSel.length && this.catSel.indexOf(c.cat) < 0) return false;
        // sub-category chips (OR within, AND with the rest)
        if (this.subcatSel.length && !this.subcatSel.some(function (h) { return c.subcats.indexOf(h) >= 0; })) return false;
        // sliders
        for (var i = 0; i < this.sliders.length; i++) {
          var s = this.sliders[i]; if (!this.sliderActive(s)) continue;
          var v = this.cardValue(c, s);
          if (v == null || v < s.lo || v > s.hi) return false;
        }
        // tag groups (AND across groups, OR within)
        for (var g = 0; g < this.groups.length; g++) {
          var grp = this.groups[g]; if (!grp.sel.length) continue;
          var ok = grp.sel.some(function (slug) { return c.tags.indexOf(grp.ns + ':' + slug) >= 0; });
          if (!ok) return false;
        }
        // flavour families
        if (this.flavour && this.flavour.sel.length) {
          var f = this.flavour.sel.some(function (fam) { return c.fams.indexOf(fam) >= 0; });
          if (!f) return false;
        }
        // availability (dedicated "In stock only" control)
        if (this.availabilityOn && !c.instock) return false;
        // NZS-TFS: Tested for Sport toggle — any cert:* tag qualifies
        if (this.testedOn && !c.tags.some(function (t) { return t.indexOf('cert:') === 0; })) return false;
        // toggles
        for (var t = 0; t < this.toggles.length; t++) {
          var tg = this.toggles[t]; if (!tg.on) continue;
          if (tg.key === 'on_sale') { if (!c.onsale) return false; continue; }
          var def = this.cfg.toggleDefs[tg.key]; if (def && !this.togglePass(c, def)) return false;
        }
        return true;
      },

      /* ---------- apply + sort ---------- */
      apply(writeUrl) {
        if (!this.ready) return;
        if (writeUrl !== false) this.filterIntent();
        if (writeUrl !== false) this.cpPage = 1;   // NZS-PGN: any user-driven change restarts the client pager
        var n = 0;
        this.cards.forEach(function (c) {
          var ok = this.matches(c);
          c.el.classList.toggle('nzs-hidden', !ok);
          if (ok) n++;
        }.bind(this));
        this.count = n;
        /* NZS-TRUECOUNT: with no filters active and later pages not yet fetched, n only counts
           loaded cards (36) — show the true collection total instead. Filtered counts keep the
           loaded-cards semantics unchanged. */
        if (!this.anyActive() && !this._allPagesLoaded && this.total > n) this.count = this.total;
        this.applySort();
        this.resetWindow();
        if (writeUrl !== false) this.writeUrl();
      },
      applyDebounced() { clearTimeout(this._t); this._t = setTimeout(function () { this.apply(); }.bind(this), 120); },
      applySort() {
        if (!this.grid) return;
        var key = this.sort, arr;
        if (key === 'featured') { arr = this.order.slice(); }
        else {
          arr = this.cards.slice().sort(function (a, b) {
            switch (key) {
              case 'price-asc': return (a.price || 0) - (b.price || 0);
              case 'price-desc': return (b.price || 0) - (a.price || 0);
              case 'pps-asc': return (a.pps == null ? 1e12 : a.pps) - (b.pps == null ? 1e12 : b.pps);
              case 'srv-desc': return (b.srv || 0) - (a.srv || 0);
              case 'title-asc': return a.title < b.title ? -1 : a.title > b.title ? 1 : 0;
            }
            return 0;
          }).map(function (c) { return c.el; });
        }
        var frag = document.createDocumentFragment();
        arr.forEach(function (el) { frag.appendChild(el); });
        this.grid.appendChild(frag);
      },

      /* ---------- control handlers ---------- */
      onSlider(s) { if (s.lo > s.hi) { var t = s.lo; s.lo = s.hi; s.hi = t; } this.applyDebounced(); this.writeUrl(true); },
      pct(s, v) { return ((v - s.min) / (s.max - s.min) * 100); },
      fmt(s, v) {
        var x = v / s.div;
        if (s.unit === '$') return '$' + x.toFixed(2);
        if (s.unit === 'mg') return Math.round(v) + 'mg';
        if (s.unit === 'g') return (Math.round(x * 10) / 10) + 'g';
        return Math.round(x);
      },
      toggleCheck(arr, val) { var i = arr.indexOf(val); if (i >= 0) arr.splice(i, 1); else arr.push(val); this.apply(); },
      toggleAvailability() { this.availabilityOn = !this.availabilityOn; this.apply(); },
      setSort(k) { this.sort = k; this.apply(); },
      get sortLabel() { var s = this.sorts.filter(function (x) { return x.key === this.sort; }.bind(this))[0]; return s ? s.label : 'Featured'; },
      setDensity(d) { this.density = d; this.listLayout = d === 'list'; localStorage.setItem('nzs-density3', d); this.writeUrl(); this.$nextTick(function () { this.repadWindow(); }.bind(this)); },
      setCat(k) { this.cat = (this.cat === k ? '' : k); this.buildControls(); this.apply(); },

      /* ---------- NZS-PGN: Products/page selector + client pager (Blake 2026-07-20) ---------- */
      setPerPage(n) {
        n = parseInt(n, 10) || 0;
        if ([20, 30, 40, 50, 60].indexOf(n) < 0) n = 0;
        this.perPage = n;
        this.cpPage = 1;
        try { if (n) localStorage.setItem('nzsPerPage', String(n)); else localStorage.removeItem('nzsPerPage'); } catch (e) { }
        if (this.clientPaging && !this._allPagesLoaded) this.filterIntent();   // fetch the server pages the window needs
        this.apply(false);   // re-window only; the URL stays a server concern (?page untouched)
      },
      cpGo(n) {
        if (!this.clientPaging) return;
        n = Math.max(1, Math.min(n, this.cpPages || 1));
        if (n === this.cpPage) return;
        this.cpPage = n;
        this.applyWindow();
        var y = this.grid ? this.grid.getBoundingClientRect().top + window.pageYOffset -
          ((parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--nzs-hdr-b')) || 0) + 16) : 0;
        try { window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' }); } catch (e) { window.scrollTo(0, Math.max(0, y)); }
      },

      anyActive() {
        // NZS-CATCHIPS: a picked shop-all category chip counts as an active filter (drives the full page
        // load + the filtered count); NZS-TFS: so does the Tested for Sport toggle.
        return this.sliders.some(this.sliderActive) || this.groups.some(function (g) { return g.sel.length; }) ||
          (this.flavour && this.flavour.sel.length) || this.toggles.some(function (t) { return t.on; }) || this.availabilityOn || this.testedOn || this.subcatSel.length || this.catSel.length || (this.shopAll && !!this.cat);
      },
      reset() {
        this.sliders.forEach(function (s) { s.lo = s.min; s.hi = s.max; });
        this.groups.forEach(function (g) { g.sel.splice(0); });
        if (this.flavour) this.flavour.sel.splice(0);
        this.toggles.forEach(function (t) { t.on = false; });
        this.availabilityOn = false;
        this.testedOn = false;
        this.subcatSel.splice(0);
        this.catSel.splice(0);
        if (this.shopAll) this.cat = '';
        this.apply();
      },

      /* ---------- URL state ---------- */
      writeUrl(replace) {
        if (!this.ready) return;
        var url = new URL(location.href), p = url.searchParams;
        var managed = ['cat', 'catf', 'sub', 'price', 'pps', 'srv', 'grams', 'flavour', 't', 'tfs', 'avail', 'sort', 'density', 'page'];
        (this.cfg.tagGroups || []).forEach(function (g) { managed.push(g.ns); });
        Object.keys(this.cfg.categories || {}).forEach(function (k) { (this.cfg.categories[k].ingredients || []).forEach(function (i) { managed.push(i.key); }); }.bind(this));
        managed.forEach(function (key) { p.delete(key); });
        if (this.isSearch) p.set('type', this.baseParams.get('type'));
        if (this.shopAll && this.cat) p.set('cat', this.cat);
        if (this.catSel.length) p.set('catf', this.catSel.join(','));
        if (this.subcatSel.length) p.set('sub', this.subcatSel.join(','));
        this.sliders.forEach(function (s) { if (this.sliderActive(s)) p.set(s.kind === 'ing' ? s.key : s.kind, s.lo + '-' + s.hi); }.bind(this));
        this.groups.forEach(function (g) { if (g.sel.length) p.set(g.ns, g.sel.join(',')); });
        if (this.flavour && this.flavour.sel.length) p.set('flavour', this.flavour.sel.join(','));
        var on = this.toggles.filter(function (t) { return t.on; }).map(function (t) { return t.key; });
        if (on.length) p.set('t', on.join(','));
        if (this.availabilityOn) p.set('avail', '1');
        if (this.testedOn) p.set('tfs', '1');
        if (this.sort !== 'featured') p.set('sort', this.sort);
        if (this.density !== 'small') p.set('density', this.density);
        try { history[replace ? 'replaceState' : 'pushState']({}, '', url.href); } catch (e) {}
      },
      hydrateFromUrl() {
        var url = new URL(location.href);
        var p = url.searchParams;
        if (p.has('cat') && this.shopAll) { this.cat = p.get('cat'); this.buildControls(); }
        if (p.get('catf')) this.catSel = p.get('catf').split(',').filter(Boolean);
        if (p.get('sub')) this.subcatSel = p.get('sub').split(',').filter(Boolean);
        this.sliders.forEach(function (s) {
          var raw = p.get(s.kind === 'ing' ? s.key : s.kind); if (!raw) return;
          var m = raw.split('-'); if (m.length === 2) { var lo = parseFloat(m[0]), hi = parseFloat(m[1]); if (isFinite(lo)) s.lo = Math.max(s.min, lo); if (isFinite(hi)) s.hi = Math.min(s.max, hi); }
          if (s.kind === 'ing' && this.sliderActive(s) && !s._openRestored) s.open = true;
        }.bind(this));
        this.groups.forEach(function (g) {
          var raw = p.get(g.ns);
          if (raw) g.sel = raw.split(',').filter(Boolean);
          if (g.sel.length && !g._openRestored) g.open = true;
          if (g.ns === 'brand' && g.sel.some(function (slug) { return g.options.slice(8).some(function (o) { return o.slug === slug; }); })) g.showAll = true;
        });
        if (this.flavour && p.get('flavour')) {
          this.flavour.sel = p.get('flavour').split(',').filter(Boolean);
          if (this.flavour.sel.length && !this.flavour._openRestored) this.flavour.open = true;
        }
        if (p.get('t')) { var on = p.get('t').split(','); this.toggles.forEach(function (t) { t.on = on.indexOf(t.key) >= 0; }); }
        if (p.get('avail') === '1') this.availabilityOn = true;
        if (p.get('tfs') === '1') this.testedOn = true;
        if (p.get('sort')) this.sort = p.get('sort');
        if (p.get('density') && p.get('density') !== 'list') this.density = p.get('density');
      },

      /* ---------- infinite-scroll render window (render first 4 rows, reveal 3 rows at a time) ---------- */
      readCols() {
        var n = 0;
        if (this.grid) {
          var tpl = getComputedStyle(this.grid).gridTemplateColumns;
          if (tpl && tpl !== 'none') n = tpl.split(' ').filter(Boolean).length;
        }
        if (!n) {
          var wide = window.matchMedia('(min-width:768px)').matches;
          if (this.density === 'list') n = 1;
          else if (this.density === 'large') n = wide ? 2 : 1;
          else n = wide ? ((this.grid && parseInt(getComputedStyle(this.grid).getPropertyValue('--nzs-cols'), 10)) || 4) : 2;
        }
        return Math.max(1, n);
      },
      windowConsts() { var cols = this.readCols(); return { cols: cols, WINDOW0: 4 * cols, STEP: 3 * cols }; },
      setupScroll() {
        if (!this.grid) return;
        this.sentinel = this.$root.querySelector('[data-nzs-sentinel]');
        this.loaderEl = this.$root.querySelector('[data-nzs-scroll-loader]');
        var self = this;
        if (this.sentinel && 'IntersectionObserver' in window) {
          this._io = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) { if (entries[i].isIntersecting) { self.onSentinel(); break; } }
          }, { root: null, rootMargin: '600px 0px', threshold: 0 });
          this._io.observe(this.sentinel);
        }
        window.addEventListener('resize', function () { clearTimeout(self._rt); self._rt = setTimeout(function () { self.onResize(); }, 150); });
      },
      resetWindow() { var k = this.windowConsts(); this.shown = k.WINDOW0; this.applyWindow(); },
      repadWindow() {
        var k = this.windowConsts();
        if (this.shown < k.WINDOW0) this.shown = k.WINDOW0;
        else this.shown = Math.ceil(this.shown / k.cols) * k.cols;
        this.applyWindow();
      },
      applyWindow() {
        if (!this.grid) return;
        var k = this.windowConsts(); this._cols = k.cols;
        if (!this.shown || this.shown < k.WINDOW0) this.shown = k.WINDOW0;
        /* NZS-PGN visibility modes:
           'page'   — Products/page selector active: show matches (cpPage-1)*perPage .. cpPage*perPage.
           'window' — filtering (or /search): keep the scroll-reveal window over loaded matches.
           'all'    — unfiltered default browse: show up to the server page size (36) and lean on the
                      real ?page=N pagination. No scroll-driven extending or fetching. */
        var mode = this.clientPaging ? 'page' : ((this.isSearch || this.anyActive()) ? 'window' : 'all');
        var kids = this.grid.children, el, i, lo = 0, hi = Infinity, matching = 0;
        if (mode === 'window') { hi = this.shown; }
        else if (mode === 'all') { hi = this._srvPpg; }
        else {
          for (i = 0; i < kids.length; i++) { el = kids[i]; if (el.hasAttribute && el.hasAttribute('data-nzs-card') && !el.classList.contains('nzs-hidden')) matching++; }
          this.cpPages = Math.max(1, Math.ceil(matching / this.perPage));
          if (this.cpPage > this.cpPages) this.cpPage = this.cpPages;
          lo = (this.cpPage - 1) * this.perPage;
          hi = lo + this.perPage;
          matching = 0;
        }
        if (mode !== 'page') this.cpPages = 1;
        var newly = [], stubsNewly = [];
        for (i = 0; i < kids.length; i++) {
          el = kids[i];
          if (!el.hasAttribute || !el.hasAttribute('data-nzs-card')) continue;
          if (el.classList.contains('nzs-hidden')) { el.classList.remove('nzs-paged'); continue; }
          matching++;
          if (matching > lo && matching <= hi) {
            if (el.classList.contains('nzs-paged')) el.classList.remove('nzs-paged');
            if (!el._nzsRevealed) { el._nzsRevealed = true; newly.push(el); }
            if (el.hasAttribute('data-nzs-stub')) stubsNewly.push(el);
          } else {
            el.classList.add('nzs-paged');
          }
        }
        this._matchingCount = matching;
        this.revealCards(newly);
        if (stubsNewly.length) this.upgradeStubs(stubsNewly);
        this.updateSentinel(matching);
      },
      /* ---------- render-window stub upgrade (Blake 2026-07-10) ----------
         Stub cards (data-nzs-stub) carry every filter/sort data-* attribute already (same wrapper as
         a full card -- see nzs-collection.liquid), so filtering/sorting/facets are unaffected. This
         only swaps the INNER card HTML for the ones the user is about to scroll to. One background
         fetch of ?view=nzs-full (render_window:0, layout:false -- see templates/collection.nzs-full.json)
         is cached for the whole page; missing/failed fetch just leaves stubs in place (they still have
         a real <a href> to the PDP, so nothing is unreachable, only unhydrated). */
      fetchFull() {
        if (_nzsFullP) return _nzsFullP;
        var self = this;
        var url = location.pathname + '?view=nzs-full';
        if (this.isSearch) {
          var searchUrl = new URL(location.href);
          searchUrl.searchParams.set('type', this.baseParams.get('type'));
          searchUrl.searchParams.set('view', 'nzs-full');
          url = searchUrl.href;
        }
        _nzsFullP = fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var map = {}, nodes = doc.querySelectorAll('[data-nzs-card][data-pid]');
            Array.prototype.forEach.call(nodes, function (n) { map[n.getAttribute('data-pid')] = n.innerHTML; });
            self._fullMap = map;
          })
          .catch(function () {});
        return _nzsFullP;
      },
      upgradeStubs(els) {
        var self = this;
        this.fetchFull().then(function () { self.applyFullMap(els); });
      },
      applyFullMap(els) {
        if (!this._fullMap) return;
        var self = this, upgraded = [];
        els.forEach(function (el) {
          if (!el.hasAttribute('data-nzs-stub')) return;
          var html = self._fullMap[el.getAttribute('data-pid')];
          if (html == null) return;
          el.innerHTML = html;
          el.removeAttribute('data-nzs-stub');
          if (window.Alpine && window.Alpine.initTree) window.Alpine.initTree(el);
          upgraded.push(el);
        });
        if (upgraded.length) self.revealCards(upgraded);
      },
      updateSentinel(matching) {
        /* NZS-PGN: the sentinel now only steps through ALREADY-LOADED matches while filtering (or on
           /search). It never triggers a page fetch — unfiltered browsing uses the real ?page=N links. */
        var more = !this.clientPaging && (this.isSearch || this.anyActive()) && this.shown < matching;
        if (this.sentinel) this.sentinel.style.display = more ? '' : 'none';
        if (!more && !this._loadingMore) this.showLoader(false);
      },
      showLoader(on) { if (this.loaderEl) { if (on) this.loaderEl.removeAttribute('hidden'); else this.loaderEl.setAttribute('hidden', ''); } },
      onSentinel() {
        if (!this.ready || this._winBusy) return;
        /* NZS-PGN: scroll no longer fetches page N+1 (the old infinite scroll). Reveal-on-scroll only
           steps through matches already in the DOM, and only while filtering / on search. Page fetches
           now happen exclusively via filterIntent() (any filter) and setPerPage() (per-page selector). */
        if (this.clientPaging || (!this.isSearch && !this.anyActive())) return;
        if (this.shown >= this._matchingCount) return;
        this._winBusy = true; this.showLoader(true);
        var self = this, k = this.windowConsts();
        setTimeout(function () { self.shown += k.STEP; self.applyWindow(); self.showLoader(false); self._winBusy = false; }, 280);
      },
      onResize() {
        var cols = this.readCols();
        if (cols === this._cols) return;
        this.repadWindow();
      },
      /* reveal a batch imperatively so a windowed image can never stay stuck at opacity:0; force the
         in-window images to load now so the first 4 rows (and each scrolled batch) are ready, and the
         hover/2nd image is loaded before Splide mounts (kills the hover-fades-to-white). */
      revealCards(els) {
        if (!els || !els.length) return;
        els.forEach(function (card) {
          card.querySelectorAll('img.skeleton-image, img[loading="lazy"]').forEach(function (im) {
            var done = function () {
              im.classList.add('img-loaded', 'active');
              var sk = im.closest('.skeleton-image'); if (sk) sk.classList.remove('animate-Xpulse', 'skeleton-image');
              var ct = im.closest('.animate_transition_card__image'); if (ct) ct.classList.add('active', 'lazy_active');
            };
            if (im.complete && im.naturalWidth > 0) { done(); }
            else { im.addEventListener('load', done, { once: true }); im.addEventListener('error', done, { once: true }); im.loading = 'eager'; }
          });
        });
      }
    };
  }

  document.addEventListener('alpine:init', function () { try { window.Alpine.data('nzsFilters', nzsFilters); } catch (e) { console.error('[nzs] nzsFilters init failed', e); } });
  if (window.Alpine && window.Alpine.version) { try { window.Alpine.data('nzsFilters', nzsFilters); } catch (e) {} }
})();

;(function(){ if(window.__nzsCciBound) return; window.__nzsCciBound=true;
  document.addEventListener('click', function(e){
    var b=e.target.closest('.nzs-cci__sum'); if(!b) return;
    var c=b.closest('.nzs-cci'); if(!c) return;
    var open=c.classList.toggle('is-open');
    b.setAttribute('aria-expanded', open?'true':'false');
  });
})();
